import { apiUrl as API_BASE_URL } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';
import toast, { Toaster } from "react-hot-toast"

export const getScraperStatus = async (filters = {}) => {
    const token = await UserProfile.getToken();
    const response = await axios.get(`${API_BASE_URL}scraper/beautiful-soup-status/`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: filters
    });
    return response
};

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Assuming JWT auth
    }
});

export const scraperOpsAPI = {
    // Basic CRUD operations for lanes
    filter: (filters = {}) => api.get('scraper/', { params: filters }),
};

// Add request interceptor to include the token dynamically before each request
api.interceptors.request.use(async (config) => {
    const token = await UserProfile.getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;  // Include token in Authorization header
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
